<template>
  <div :class="classes()">
    <div :class="`${el}__button`" @click="modal = true">
      <Icon :class="`${el}__icon`" name="illu-feedback" size="xl" />
      <template v-if="$matchMedia.l">{{ $t('feedback.button') }}</template>
    </div>

    <Modal :headline="$t('feedback.modal.headline')" :open="modal" @close="modal = false" size="m">
      <div v-if="showIframe" :class="`${el}__survey`" id="lp_survey_558574"></div>
    </Modal>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Modal from '@/components/Modal';

import { LAMAPOLL_URL } from '@/constants/generics';

export default {
  name: 'FeedbackLayer',
  props: {},
  components: { Icon, Modal },
  watch: {
    modal() {
      if (!this.modal) {
        // Refresh iframe to start from beginning
        this.showIframe = false;
        setTimeout(() => (this.showIframe = true), 1);
      }
      window.lp_load_survey('lp_survey_558574', LAMAPOLL_URL, 'contain');
    },
  },
  data() {
    return {
      LAMAPOLL_URL,
      modal: false,
      showIframe: true,
      el: 'c-feedbackLayer',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--open`]: this.modal,
        };
      },
    };
  },
};
</script>
